import { IconButton, InputAdornment, TextFieldProps } from '@material-ui/core';
import { useState } from 'react';
import TextInput from '.';
import { FormikPropType } from '../Formik';
import './SecureInput.scss';

export default function SecureInput({
    label,
    showSecure = true,
    ...rest
}: TextFieldProps & { showSecure?: boolean }) {
    const [showPassword, setPassword] = useState<boolean>(false);
    return (
        <div className="secure-input">
            <TextInput
                {...rest}
                type={!showPassword ? 'password' : 'text'}
                id="outlined-adornment-password"
                label={label}
                onPaste={(e) => {
                    e.preventDefault();
                    return false;
                }}
                InputProps={{
                    endAdornment: showSecure && (
                        <InputAdornment position="end">
                            <IconButton
                                className="password-toggle-button"
                                onClick={() => setPassword(!showPassword)}
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                aria-pressed={showPassword}
                                edge="end"
                                size="small"
                            >
                                {showPassword ? (
                                    <img
                                        src="/images/eye-open.svg"
                                        alt="Password visible"
                                        className="password-toggle-icon"
                                    />
                                ) : (
                                    <img
                                        src="/images/eye-close.svg"
                                        alt="Password hidden"
                                        className="password-toggle-icon"
                                    />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                    'aria-describedby': `${rest.id || 'outlined-adornment-password'}-helper-text`,
                }}
            />
        </div>
    );
}
